
import { createRouter, createWebHistory } from "vue-router";
import { adminRoutes } from "./modules/admin";

const routes = [
    ...adminRoutes,
    {
        name: "layout",
        path: "/",
        component: () => import("@/views/Layout/index.vue"),
        children: [
            {
                // 二级路由
                path: "/",
                name: "Home",
                component: () => import("@/views/home/index.vue"),
                meta: {
                    title: "首页",
                    isLogin: true,
                    isMainNav: true,
                    isHeader: true,
                    breadcrumb: true // 面包屑导航
                }
            },
            {
                path: "/goods-list",
                name: "GoodsList",
                component: () => import("@/views/goods-list/index.vue"),
                meta: {
                    title: "商品列表",
                    isLogin: true,
                    isMainNav: true,
                    isHeader: true,
                    breadcrumb: true // 面包屑导航
                }
            },
            {
                path: "/search-list",
                name: "SearchList",
                component: () => import("@/views/search-list/index.vue"),
                meta: {
                    title: "搜索商品列表",
                    isLogin: true,
                    isMainNav: true,
                    isHeader: true,
                    breadcrumb: true // 面包屑导航
                }
            },
            {
                // 二级路由
                path: "/cart",
                name: "Cart",
                component: () => import("@/views/cart/index.vue"),
                meta: {
                    title: "购物车",
                    isLogin: true,
                    isMainNav: true,
                    isHeader: true
                }
            },
            {
                // 二级路由
                path: "/cart/confirm",
                name: "CartConfirm",
                component: () => import("@/views/cart/confirm.vue"),
                meta: {
                    title: "确认订单",
                    isLogin: false,
                    isMainNav: true,
                    isHeader: true
                }
            },
            {
                // 二级路由
                path: "/cart/confirm/result",
                name: "CartConfirmResult",
                component: () => import("@/views/cart/confirm-result.vue"),
                meta: {
                    title: "确认订单结果",
                    isLogin: false,
                    isMainNav: true,
                    isHeader: true
                }
            },
            // 商品详情
            {
                path: "/goods-detail",
                name: "GoodsDetail",
                component: () => import("@/views/goods-detail/index.vue"),
                meta: {
                    title: "商品详情",
                    isLogin: true,
                    isHeader: true,
                    isMainNav: true,
                    breadcrumb: true // 面包屑导航
                }
            },
            {
                path: "/order",
                name: "Order",
                component: () => import("@/views/me/order-list/index.vue"),
                meta: {
                    title: "我的订单",
                    isLogin: true,
                    isMainNav: true,
                    isHeader: true,
                    breadcrumb: true // 面包屑导航
                }
            },
            {
                path: "/often-buy-list",
                name: "OftenBuyList",
                component: () => import("@/views/often-buy-list/index.vue"),
                meta: {
                    title: "常购清单",
                    isLogin: true,
                    isMainNav: true,
                    isHeader: true,
                    breadcrumb: true // 面包屑导航
                }
            }
        ]
    },
    {
        name: "login",
        path: "/login",
        component: () => import("@/views/Login/index.vue"),
        meta: {
            title: "登录",
            isLogin: false
        }
    },
    {
        name: "refresh",
        path: "/refresh",
        component: () => import("@/views/refresh.vue"),
        meta: {
            title: "刷新",
            isLogin: false
        }
    }
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: routes,
    scrollBehavior(to: any, from: any, savedPosition: any) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0
            };
        }
    }
});

// 路由守卫：记录访问路径到sessionStorage
router.afterEach((to) => {
    // 只记录配置了breadcrumb的页面
    if (to.meta.breadcrumb) {
        let breadcrumbList = JSON.parse(sessionStorage.getItem("breadcrumbList")as any) || [];

        // 去重：避免重复添加同一页面（如多次点击同一分类）
        console.log(to);
        const isExisted = breadcrumbList.some((item:any) => item.path === to.fullPath);
        if (!isExisted) {
            // 存储路径、标题、参数（方便跳转）
            breadcrumbList.push({
                name: to.meta.title,
                path: to.fullPath,
                params: to.query
            });
            // 限制最大层级（可选，避免路径过长）
            if (breadcrumbList.length > 5) {
                breadcrumbList = breadcrumbList.slice(-5);
            }
            sessionStorage.setItem("breadcrumbList", JSON.stringify(breadcrumbList));
        }
    }
});


export default router;
